<script>
import { mapState } from 'vuex';
import Length from '../../components/length.vue';

export default {
    name: "list",
    data() {
        return {};
    },
    computed: {
        ...mapState(['shoppingData']),
        allPrice() { 
            let allPrice = 0;
            this.shoppingData.forEach(v => {
                allPrice += parseFloat(v.price * v.length);
            });
            return allPrice.toFixed(2);
        },
    },
    components: {
        Length,
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        lengthChange(num, item, index) { 
            if (this.time) clearTimeout(this.time);
            this.time = setTimeout(() => { 
                this.$showLoading();
                this.$store.dispatch('setShopCartCount', {
                    cart_id: item.id,
                    count: num
                }).then((result) => {
                    this.$hideLoading();
                    if (result.code == 100) {
                        this.$showToast({ text: '修改成功' });
                        // 修改单个商品的数量和总格
                        let data = {
                            ...item,
                            count: num,
                            length: num,
                            total_price: (parseFloat(item.price) * num).toFixed(2)
                        };
                        this.$set(this.shoppingData, index, data);
                        // 修改所有商品总价
                        // this.resetAllPrice();
                    } else if (result.code == 90) {
                        this.$showToast({ text: '登录凭证已失效' });
                        this.toLogin();
                    } else if (result.code == 102) { 
                        this.$showToast({ text: '修改失败，库存不足' });
                        // 修改失败，重置数量
                        this.resetLength(index, item);
                    } else {
                        this.$showToast({ text: '修改错误' });
                        // 修改失败，重置数量
                        this.resetLength(index, item);
                    }
                }).catch((err) => {
                    this.$hideLoading();
                    this.$showToast({ text: '修改错误' });
                });
            }, 300);
        },
        // 重置商品数量length
        resetLength(index, item) { 
            let data = {
                ...item,
                length: item.count
            }
            this.$set(this.shoppingData, index, data);
        },
        // 重新计算总价
        // resetAllPrice() { 
        //     let allPrice = 0;
        //     this.list.forEach(v => {
        //         allPrice += parseFloat(v.total_price)
        //     });
        //     this.allPrice = allPrice.toFixed(2);
        // },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
        // 删除
        deleteGoods(item, index) {
            this.$showLoading();
            this.$store.dispatch('deleteShopCart', {
                cart_id: item.id
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) { 
                    this.$showToast({ text: '删除成功' });
                    this.shoppingData.splice(index, 1);
                    // 修改所有商品总价
                    // this.resetAllPrice();
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else {
                    this.$showToast({ text: '删除失败' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: '删除失败' });
            });
        },
    },
};
</script>

<template>
    <div class="wrapper">
        <div class="list">
            <div class="item flex" v-for="(item, index) in shoppingData" :key="index">
                <router-link :to="item.type == 1 ? `/shop/detail?id=${item.goods_id}` : `/gallery/works/detail?id=${item.goods_id}`">
                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                </router-link>
                <div class="content flex flex_column justify_between">
                    <div class="info">
                        <p class="name"><router-link :to="item.type == 1 ? `/shop/detail?id=${item.goods_id}` : `/gallery/works/detail?id=${item.goods_id}`">{{ item.name }}</router-link></p>
                        <p class="price" v-if="item.price == '0.00'">免费</p>
                        <p class="price" v-else>RMB {{ item.price }}</p>
                    </div>
                    <div class="bottom flex justify_end align_center">
                        <div class="btn_del" v-if="!item.isShowDelete" @click="item.isShowDelete = true">删除</div>
                        <template v-else>
                            <div class="btn_del confirm" @click="deleteGoods(item, index)">确认删除</div>
                            <div class="btn_del" @click="item.isShowDelete = false">取消</div>
                        </template>
                        <Length v-model="item.length" min="1" @change="lengthChange($event, item, index)"/>
                        <div class="price">RMB {{ item.total_price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="all_price flex justify_end">
            <div class="content">
                <p class="row freight_free">您的订单可享受中国境内免费送货服务</p>
                <div class="row price_wrap flex justify_between">
                    <p class="name">总计：</p>
                    <p class="price">RMB {{ allPrice }}</p>
                </div>
                <router-link class="btn layout_flex_center" to="/shopping/order">购买物品</router-link>
            </div>
        </div>
        <div class="go_on_shopping flex justify_between align_center">
            <p class="name">继续购物</p>
            <div class="btn_group flex">
                <div class="btn"></div>
                <div class="btn"></div>
                <div class="btn"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.go_on_shopping{
    padding: .2rem 0;
    .name{
        font-size: .18rem;
        color: #666;
    }
    .btn_group{
        gap: .15rem;
        .btn{
            width: .7rem;
            height: .4rem;
            border: 1px solid #999;
            border-radius: .04rem;
        }
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        .name{
            font-size: .26rem;
            margin-bottom: .4rem;
        }
        .btn_group{
            gap: .2rem;
            .btn{
                width: .94rem;
                height: .5rem;
            }
        }
    }
}
.all_price{
    border-bottom: 1px solid #999;
    .content{
        font-size: .18rem;
        width: 17em;
        padding: .3rem 0;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .row{
            padding: .1rem 0;
            margin-bottom: .2rem;
            border-bottom: 1px solid #b1b1b1;
            @media only screen and (max-width: 750px) {
                padding: .2rem 0;
            }
        }
        .freight_free{
            font-size: .18rem;
            color: #666;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .price_wrap{
            .name{
                font-size: .18rem;
                color: #666;
            }
            .price{
                font-size: .26rem;
            }
            @media only screen and (max-width: 750px) {
                margin-bottom: .4rem;
                .name,
                .price{
                    font-size: .26rem;
                }
            }
        }
        .btn{
            width: 100%;
            height: .6rem;
            border: 1px solid #999;
            cursor: pointer;
            color: #666;
            &::after{
                content: "";
                display: block;
                width: .08rem;
                height: .08rem;
                border-right: 1px solid #666;
                border-top: 1px solid #666;
                transform: rotate(45deg);
                margin-left: .06rem;
            }
            @media only screen and (max-width: 750px) {
                font-size: .25rem;
                height: .7rem;
                margin-bottom: .2rem;
                &::after{
                    width: .1rem;
                    height: .1rem;
                }
            }
        }
    }
}
</style>